module.exports = __webpack_public_path__ + "img/gift.5b13908d.svg";